export type AppDetails = {
    id: number,
    name: string,
    category: string,
    rating: number,
    reviews: number,
    size: number,
    installs: number,
    type: string,
    contentRating: string,
    genres: string[],
    positiveReviews: number,
    negativeReviews: number
}

export const AppData:AppDetails[] = [
    {
        id: 1,
        name: "Coloring book moana",
        category: "ART_AND_DESIGN",
        rating: 3.9,
        reviews: 967,
        size: 14,
        installs: 500000,
        type: "Free",
        contentRating:"Everyone",
        genres:["Art & Design","Pretend Play"],
        positiveReviews: 500,
        negativeReviews: 400
    },
    {
        id: 2,
        name: "Real Tractor Farming",
        category: "AUTO_AND_VEHICLES",
        rating: 4,
        reviews: 1598,
        size: 56,
        installs: 1000000,
        type: "Free",
        contentRating:"Everyone",
        genres:["Auto & Vehicles"],
        positiveReviews: 1000,
        negativeReviews: 450,
    },
    {
        id: 3,
        name: "Ulta Beauty",
        category: "BEAUTY",
        rating: 4.7,
        reviews: 42050,
        size: 80,
        installs: 1000000,
        type: "Free",
        contentRating:"Everyone",
        genres:["Beauty"],
        positiveReviews: 30000,
        negativeReviews: 12000,
    },
    {
        id: 4,
        name: "Wikipedia",
        category: "BOOKS_AND_REFERENCE",
        rating: 4.4,
        reviews: 577550,
        size: 29,
        installs: 10000000,
        type: "Free",
        contentRating:"Everyone",
        genres:["Books & Reference"],
        positiveReviews: 400000,
        negativeReviews: 170000,
    },
    {
        id: 5,
        name: "Coloring book moana",
        category: "ART_AND_DESIGN",
        rating: 3.9,
        reviews: 967,
        size: 14,
        installs: 500000,
        type: "Free",
        contentRating:"Everyone",
        genres:["Art & Design","Pretend Play"],
        positiveReviews: 450,
        negativeReviews: 500,
    },
    {
        id: 6,
        name: "BT Share It",
        category: "BUSINESS",
        rating: 4.7,
        reviews: 12,
        size: 13,
        installs: 500,
        type: "Free",
        contentRating:"Everyone",
        genres:["Business"],
        positiveReviews: 1,
        negativeReviews: 10,
    },
    {
        id: 7,
        name: "Manga Books",
        category: "COMICS",
        rating: 3.8,
        reviews: 7326,
        size: 35,
        installs: 500000,
        type: "Paid",
        contentRating:"Adults only 18+",
        genres:["Comics"],
        positiveReviews: 4000,
        negativeReviews: 3000,
    },
    {
        id: 8,
        name: "Sketch - Draw & Paint",
        category: "ART_AND_DESIGN",
        rating: 4.5,
        reviews: 215644,
        size: 25,
        installs: 50000000,
        type: "Free",
        contentRating:"Teen",
        genres:["Art & Design"],
        positiveReviews: 100000,
        negativeReviews: 110000,
    },
    {
        id: 9,
        name: "DraftKings - Daily Fantasy Sports",
        category: "SPORTS",
        rating: 4.5,
        reviews: 50017,
        size: 41,
        installs: 1000000,
        type: "Paid",
        contentRating:"Adults only 18+",
        genres:["Sports"],
        positiveReviews: 45000,
        negativeReviews: 5000,
    },
    {
        id: 10,
        name: "OkCupid Dating",
        category: "DATING",
        rating: 4.1,
        reviews: 285726,
        size: 15,
        installs: 10000000,
        type: "Free",
        contentRating:"Mature 17+",
        genres:["Dating"],
        positiveReviews: 270000,
        negativeReviews: 15000,
    },
    {
        id: 11,
        name: "Find Lover",
        category: "DATING",
        rating: 4.9,
        reviews: 21,
        size: 4.7,
        installs: 1000,
        type: "Free",
        contentRating:"Mature 17+",
        genres:["DATING"],
        positiveReviews: 10,
        negativeReviews: 11,
    },
    {
        id: 12,
        name: "Bible",
        category: "BOOKS_AND_REFERENCE",
        rating: 4.7,
        reviews: 2440695,
        size: 40,
        installs: 100000000,
        type: "Free",
        contentRating:"Teen",
        genres:["Books & Reference"],
        positiveReviews: 2000000,
        negativeReviews: 400000,
    },
    
]